const getEntryForPathname = pathname => (
    pathname === '/ai' || pathname.startsWith('/ai/') ||
    pathname === '/editor' || pathname.startsWith('/editor/') ||
    pathname === '/create' || pathname.startsWith('/create/')
        ? 'editor'
        : 'portal'
);

export {
    getEntryForPathname
};
